const amberA = {
  amberA1: "hsla(40, 94.9%, 38.7%, 0.016)",
  amberA2: "hsla(40, 100%, 50.3%, 0.071)",
  amberA3: "hsla(44, 100%, 50.1%, 0.165)",
  amberA4: "hsla(43, 100%, 50.0%, 0.263)",
  amberA5: "hsla(42, 100%, 50.0%, 0.365)",
  amberA6: "hsla(38, 100%, 50.1%, 0.475)",
  amberA7: "hsla(36, 99.9%, 46.2%, 0.612)",
  amberA8: "hsla(35, 99.8%, 46.0%, 0.832)",
  amberA9: "hsla(39, 100%, 50.0%, 0.859)",
  amberA10: "hsla(35, 100%, 50.0%, 0.891)",
  amberA11: "hsla(29, 100%, 33.6%, 0.980)",
  amberA12: "hsla(20, 99.8%, 14.1%, 0.965)"
};
export { amberA };
//# sourceMappingURL=amberA.mjs.map
